import { planTypes } from '@/common/constants';

export default {
  key: planTypes.CONCURRENCY_MEETING_BASIC,
  data() {
    return {
      logo: require('@/assets/plans/concurrent-meeting-basic.svg'),
      title: '',
    };
  },
  inject: ['curPlanType'],
  computed: {
    key() {
      if (this.curPlanType) {
        return this.curPlanType;
      } else if (this?.$pkg?.key) {
        return this.$pkg.key === 'CONCURRENT_MEETING_PLUS'
          ? planTypes.CONCURRENT_MEETING_PLUS
          : planTypes.CONCURRENCY_MEETING_BASIC;
      } else {
        return '';
      }
    },
  },
  watch: {
    key: {
      immediate: true,
      deep: true,
      handler(newPlanType) {
        if (newPlanType) {
          this.planType = newPlanType;

          this.title =
            newPlanType === planTypes.CONCURRENT_MEETING_PLUS
              ? this.$t('billing.concurrent_meeting_plus.title')
              : this.$t('billing.concurrent_meeting_basic.title');
        }
      },
    },
  },
};
